<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/CarRental/CarRentalFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import DatePickerInput, {
        dateTimeNullable,
    } from '$components/Date/DatePickerInput.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const vehicleTypeOptions = [
        `Voiture citadine`,
        `SUV`,
        `Voiture berline`,
        `4×4, Pick-Up`,
        `VAN`,
        `Véhicule utilitaire`,
        `Camion de déménagement`,
    ].map((v) => ({ label: v, value: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.vehicleType}
        class=""
        let:field
        let:id
        label={`Type de véhicules`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={vehicleTypeOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(vehicleTypeOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.vehicleCapacity}
        class=""
        let:field
        let:id
        label={`Capacité du véhicule`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={[
                { label: `1 personne`, value: `1 personne`, key: `1 personne` },
                { label: `2 personnes`, value: `2 personnes`, key: `2 personnes` },
                { label: `3 personnes`, value: `3 personnes`, key: `3 personnes` },
                { label: `4 personnes`, value: `4 personnes`, key: `4 personnes` },
                { label: `5 personnes`, value: `5 personnes`, key: `5 personnes` },
                { label: `6 personnes`, value: `6 personnes`, key: `6 personnes` },
                { label: `7 personnes`, value: `7 personnes`, key: `7 personnes` },
            ]}
        />
    </Row>

    <Row {form} field={fields.withDriver} class="" let:field let:id label={`Chauffeur ?`}>
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @2xl:grid-cols-2 gap-x-8"
            choices={[`Sans chauffeur`, `Avec chauffeur`].map((v) => ({
                label: v,
                value: v,
                key: v,
            }))}
        />
    </Row>

    <div class="grid grid-cols-1 @2xl:grid-cols-2 gap-8">
        <Row
            {form}
            field={fields.departureDate}
            label={'Date et heure de départ'}
            let:field
        >
            <DatePickerInput futureDateOnly {field} {form} {...dateTimeNullable} />
        </Row>

        <Row {form} field={fields.returnDate} label={'Date et heure de retour'} let:field>
            <DatePickerInput futureDateOnly {field} {form} {...dateTimeNullable} />
        </Row>
    </div>

    <Row
        {form}
        class=""
        field={fields.pickupLocation}
        label={'Lieu de prise en charge'}
        let:field
        let:id
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={['Aéroport', 'Agence de location', 'Autre'].map((v) => ({
                label: v,
                value: v,
                key: v,
            }))}
        />
    </Row>
</div>
